import api from 'src/shared/api/axios';

export type UpcomingDeadlineKind = 'TASK' | 'RISK' | 'PAYMENT';

export type UpcomingDeadlineItem = {
    kind: UpcomingDeadlineKind;
    id: string;
    title: string;
    dueDate: string;
    badge: string;
    dday: number | null;
};

export type PaymentOverviewMonthlyRow = {
    month: string; // YYYY-MM
    netCum: number; // 누적 순현금
};

export type PaymentOverview = {
    currency: string | null;
    monthly: PaymentOverviewMonthlyRow[];
};

export type DashboardSnapshot = {
    asOfISO?: string;
    viewAs?: 'DATE' | 'WEEK';
    weekOfISO?: string;
    anchorDow?: number;
    evBasis?: 'CONFIRMED_W2' | 'CONFIRMED_W1' | 'LIVE';
    liveAvailable?: boolean;
    approvalNotice?: {
        message: string;
        weekOfISO: string;
        pendingCount: number;
    } | null;
    project: {
        id: string;
        name: string;
        code: string | null;
        clientName: string | null;
        contractPrice: any | null;
        contractCurrency: string | null;
        startDate: string | null;
        endDate: string | null;
    };

    wbsListVersion: number | null;

    progressCashflow: {
        title: string;
        subtitle?: string;
        progress: { actual: number; target?: number };
        collection: { actual: number; target?: number };
        spending: { actual: number; target?: number };
    };

    scurveRows: Array<{
        weekNo: number;
        weekLabel: string;
        weekOf: string;
        pvInc: number;
        pvCum: number;

        pvForecastInc?: number | null;
        pvForecastCum?: number | null;

        evInc: number;
        evCum: number;
        spi: number | null;
    }>;

    wbsLevel1Rows: Array<{
        id: string;
        code: string;
        title: string;
        owner: string;
        weightPct: number;
        scheduleText: string;
        pvPct: number;
        evPct: number;
        status: 'ON_TRACK' | 'AT_RISK';
    }>;

    risks: Array<{
        id: string;
        title: string;
        impact: 1 | 2 | 3 | 4 | 5;
        probability: 1 | 2 | 3 | 4 | 5;
        owner?: string;
    }>;

    taskSnapshot: {
        openCount: number;
        overdue: number;
        dueSoon: number;
        doneThisWeek: number;
        top: Array<{
            id: string;
            title: string;
            status: 'NOT_STARTED' | 'IN_PROGRESS' | 'BLOCKED' | 'DONE';
            owner?: string;
            dueDate?: string;
        }>;
    };

    upcomingDeadlinesByKind: {
        task: UpcomingDeadlineItem[];
        risk: UpcomingDeadlineItem[];
        payment: UpcomingDeadlineItem[];
    };

    // 이건 Optional
    upcomingDeadlines: UpcomingDeadlineItem[];

    // ✅ any → PaymentOverview (우선 최소필드만)
    paymentOverview?: PaymentOverview;
};

export async function getDashboardSnapshot(
    projectId: string,
    params?: { asOf?: string; viewAs?: 'DATE' | 'WEEK'; evBasis?: 'CONFIRMED_W2' | 'CONFIRMED_W1' | 'LIVE' },
) {
    const { data } = await api.get(`/projects/${projectId}/dashboard/snapshot`, { params });
    return data as { ok: boolean; data: DashboardSnapshot };
}
